import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  TextField,
  Button,
  MenuItem,
} from "@mui/material";
import { useTranslation } from "react-i18next";

export const CONTACT_TYPES = [
  { value: "service", label: "Service" },
  { value: "management", label: "Management" },
  { value: "accountant", label: "Accountant" },
  { value: "sales", label: "Sales" },
  { value: "support", label: "Support" },
  { value: "other", label: "Other" },
];

export default function ContactFormDialog({ open, onClose, onSubmit, initial }) {
  const { t } = useTranslation();

  const [form, setForm] = useState({
    type: "other",
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
  });

  useEffect(() => {
    setForm(
      initial
        ? {
            type: initial.type ?? "other",
            first_name: initial.first_name ?? "",
            last_name: initial.last_name ?? "",
            email: initial.email ?? "",
            phone: initial.phone ?? "",
          }
        : { type: "other", first_name: "", last_name: "", email: "", phone: "" }
    );
  }, [initial]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((p) => ({ ...p, [name]: value }));
  };

  const canSave = form.first_name.trim() && form.last_name.trim();

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        {initial
          ? t("contactFormDialog.title.edit", "Edit contact")
          : t("contactFormDialog.title.new", "New contact")}
      </DialogTitle>

      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              select
              label={t("contactFormDialog.fields.type", "Type")}
              name="type"
              value={form.type}
              onChange={handleChange}
            >
              {CONTACT_TYPES.map((ct) => (
                <MenuItem key={ct.value} value={ct.value}>
                  {t(`contactFormDialog.types.${ct.value}`, ct.label)}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label={t("contactFormDialog.fields.phone", "Phone")}
              name="phone"
              value={form.phone}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              required
              fullWidth
              label={t("contactFormDialog.fields.firstName", "First name")}
              name="first_name"
              value={form.first_name}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              required
              fullWidth
              label={t("contactFormDialog.fields.lastName", "Last name")}
              name="last_name"
              value={form.last_name}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              type="email"
              label={t("contactFormDialog.fields.email", "Email")}
              name="email"
              value={form.email}
              onChange={handleChange}
            />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions sx={{ px: 3, py: 1.5 }}>
        <Button onClick={onClose}>
          {t("contactFormDialog.actions.cancel", "Cancel")}
        </Button>

        <Button
          variant="contained"
          disabled={!canSave}
          onClick={() => onSubmit(form)}
        >
          {initial
            ? t("contactFormDialog.actions.save", "Save")
            : t("contactFormDialog.actions.create", "Create")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
